import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib';

type Props = {
  /** Сколько элементов список показывает */
  shown: number;
  /** Сколько элементов нашлось на сервере под тем же отбором */
  total?: number;
  /**
   * Держать место под подпись и без неё. Нужно полю с поиском на сервере: подпись пропадает
   * и возвращается по мере набора, и без запаса места поле с раскрытым списком смещалось бы,
   * а страница, прокрученная до конца, сдвигалась бы и закрывала список
   */
  isSpaceReserved?: boolean;
  className?: string;
};

/**
 * Подпись о том, что показана лишь часть найденного: сколько показано из скольких.
 * Молчаливое усечение неотличимо от конца набора, поэтому список, ограниченный порцией,
 * называет остаток и тем самым отправляет за ним в поиск.
 */
export const ListTruncationNotice: FC<Props> = ({ shown, total, isSpaceReserved = false, className }) => {
  const { t } = useTranslation('common');
  const isTruncated = total !== undefined && total > shown;

  if (!isTruncated && !isSpaceReserved) return null;

  return (
    <div className={cn('min-h-lh text-muted-foreground text-sm', className)}>
      {isTruncated && t('shownOfTotal', { shown, total })}
    </div>
  );
};
